import { PropsWithChildren } from "react";

export enum WidgetType {
  ASSET_TABLE = "asset-table",
  ASSET_CHART = "asset-chart",
  TICKET_TABLE = "ticket-table",
  TICKET_CHART = "ticket-chart",
  USER_TABLE = "user-table",
  USER_CHART = "user-chart",
}

export type WidgetState = {
  id: string;
  position: {
    index: number;
    width: number;
    height: number;
  };
  config: {
    title: string;
  };
  type: WidgetType;
  refresh?: boolean;
};

export interface WidgetContainerProps extends PropsWithChildren<WidgetState> {
  width: number;
  draggable?: boolean;
  animatable?: boolean;
}

export enum ActionTypes {
  ADD_WIDGET = "ADD_WIDGET",
  REMOVE_WIDGET = "REMOVE_WIDGET",
  SWAP_WIDGETS = "SWAP_WIDGETS",
  RESET_DATA_TABLE = "RESET_DATA_TABLE",
  RESET_REFRESH = "RESET_REFRESH",
}

export type WidgetCollection = Record<string, WidgetContainerProps>;

export type WidgetContextState = {
  widgets: WidgetCollection;
};

export type WidgetContextActions = {
  type: ActionTypes;
  payload: any;
};

